"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalActions = exports.GlobalActionTypes = void 0;
const utils_1 = require("./utils");
var GlobalActionTypes;
(function (GlobalActionTypes) {
    GlobalActionTypes["INITIALIZE_APP"] = "global/INITIALIZE_APP";
    GlobalActionTypes["SET_IS_AUTHORIZED"] = "global/SET_IS_AUTHORIZED";
    GlobalActionTypes["SET_SERVER_URL"] = "global/SET_SERVER_URL";
    GlobalActionTypes["SET_SERVER_TYPE"] = "global/SET_SERVER_TYPE";
    GlobalActionTypes["SET_SERVER_ENVIRONMENT"] = "global/SET_SERVER_ENVIRONMENT";
    GlobalActionTypes["SET_SERVER_PREFIX"] = "global/SET_SERVER_PREFIX";
    GlobalActionTypes["SET_EXTENSION_INTEGRATION"] = "global/SET_EXTENSION_INTEGRATION";
    GlobalActionTypes["HANDLE_LOGOUT"] = "global/HANDLE_LOGOUT";
    GlobalActionTypes["SET_DEFAULT_HOST"] = "global/SET_DEFAULT_HOST";
    GlobalActionTypes["RESET_WHOLE_STORE"] = "global/RESET_WHOLE_STORE";
    GlobalActionTypes["SET_IS_SHOW_GUIDE"] = "global/SET_IS_SHOW_GUIDE";
})(GlobalActionTypes = exports.GlobalActionTypes || (exports.GlobalActionTypes = {}));
exports.globalActions = {
    initializeApp: (0, utils_1.makeActionCreator)(GlobalActionTypes.INITIALIZE_APP),
    setIsAuthorized: (0, utils_1.makeActionCreator)(GlobalActionTypes.SET_IS_AUTHORIZED),
    setServerUrl: (0, utils_1.makeActionCreator)(GlobalActionTypes.SET_SERVER_URL),
    setServerType: (0, utils_1.makeActionCreator)(GlobalActionTypes.SET_SERVER_TYPE),
    setServerEnvironment: (0, utils_1.makeActionCreator)(GlobalActionTypes.SET_SERVER_ENVIRONMENT),
    setServerPrefix: (0, utils_1.makeActionCreator)(GlobalActionTypes.SET_SERVER_PREFIX),
    setExtensionIntegration: (0, utils_1.makeActionCreator)(GlobalActionTypes.SET_EXTENSION_INTEGRATION),
    handleLogout: (0, utils_1.makeActionCreator)(GlobalActionTypes.HANDLE_LOGOUT),
    setIsShowGuide: (0, utils_1.makeActionCreator)(GlobalActionTypes.SET_IS_SHOW_GUIDE),
    setDefaultHost: (0, utils_1.makeActionCreator)(GlobalActionTypes.SET_DEFAULT_HOST),
    resetWholeStore: (0, utils_1.makeActionCreator)(GlobalActionTypes.RESET_WHOLE_STORE),
};
